module.exports = __webpack_public_path__ + "img/92.9cf75aa9.webp";